import React from 'react';
import { IconProps } from '.';

const SvgCursorResize = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        d='M11.25 20h-1.5v-7.375h-4V16l-4-4 4-4v3.375h4V4h1.5v16ZM14.25 4v7.375h4V8l4 4-4 4v-3.375h-4V20h-1.5V4h1.5Z'
      />
    </svg>
  );
};

export default SvgCursorResize;
